"use strict";
document.addEventListener("instafeedAppLoaded", ()=>{
  console.log("instafeedAppLoaded")
  const instafeeds = document.querySelectorAll(".instafeed-new-layout-wrapper");
  instafeeds.forEach(item => {
    item.classList.add("owl-carousel");
    $(item).owlCarousel({
        loop:false,
        nav:true,
        dots: false,
        // rewind: true,
        responsive:{
            0:{
                items:2.2,
                margin:10
            },
            989:{
                items:5.5,
                margin:15
            }
        },
        onRefreshed: () => {
         
        }
      })
  })
})